// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"


var jQuery = require('jquery')
// include jQuery in global and window scope (so you can access it globally)
// in your web browser, when you type $('.div'), it is actually refering to global.$('.div')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
import 'jquery.appear';
import 'slick-carousel';

// Import Bootstrap and Popper.js
import 'bootstrap';
import '@popperjs/core'; // Popper.js is required for Bootstrap's JavaScript components
// import "../custom"
Rails.start()
//Turbolinks.start()
ActiveStorage.start()


// page init
jQuery(function(){
	"use strict";

	initTabs();

	initMobileNav();
	
	initNumCounter();
	initParallaxBg();
	initStickyHeader();
	initHasDropClasses();
	
	initAnimatedProgressbars();
	initJqureyAnimation();
	initGoToTopScroll();
	initPieCharts();
	initSlickSlider();
});
jQuery(window).on('load', function() {
	"use strict";
	
	initPreLoader();
	initMarquee();

	initAjaxLoad();


	initVimeoPlayer();

	initVideoPlayer();
	initYoutubePlayer();
	initStyleChanger();

	initBackgroundResize();
	initFlickrPhotos();
    initFormValidation();
	initGoToTop();
	initAccordion();
	
	initNavRemoveClass();
 
});

jQuery(window).scroll(function() {
	initPieCharts();
	initGoToTopScroll();
	initAnimatedProgressbars();
});

function initSlickSlider() {
    jQuery('.beans-slider').each(function() {
    	var item = jQuery(this);
    	var btnPrev = item.find('.btn-prev');
    	var btnNext = item.find('.btn-next');
    	var slider = item.find('.beans-slideset');
    	var pagination = item.find('.beans-pagination');

    	slider.slick({
    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
    		dots: pagination.length > 0 ? true : false,
    		pauseOnHover: false,
    		autoplay: true,
    		speed: 800
    	});

    	pagination.remove();
    	btnPrev.remove();
    	btnNext.remove();
    });

    jQuery('.beans-stepslider').each(function() {
    	var item = jQuery(this);
    	var btnPrev = item.find('.btn-prev');
    	var btnNext = item.find('.btn-next');
    	var slider = item.find('.beans-slideset');
    	var pagination = item.find('.beans-pagination');

    	slider.slick({
    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
    		dots: pagination.length > 0 ? true : false,
    		slidesToShow: 1,
    		mobileFirst: true,
    		autoplay: true,
    		responsive: [
    			{
    				breakpoint: 767,
    				settings: {
    					slidesToShow: 2
    				}
    			}, {
					breakpoint: 1024,
    				settings: {
    					slidesToShow: 4
    				}    				
    			}
    		]
    	});

    	if(item.parents('.blog-section , .finest-chef').length > 0) {
    		slider.slick('unslick');
	    	slider.slick({
	    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
	    		dots: pagination.length > 0 ? true : false,
    			autoplay: true,
	    		slidesToShow: 1,
	    		mobileFirst: true,
	    		responsive: [
	    			{
	    				breakpoint: 768,
	    				settings: {
	    					slidesToShow: 2
	    				}
	    			}, {
						breakpoint: 1024,
	    				settings: {
	    					slidesToShow: 3
	    				}    				
	    			}
	    		]
	    	});
    	}

    	if(item.parents('.related-shop').length > 0) {
    		slider.slick('unslick');
	    	slider.slick({
	    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
	    		dots: pagination.length > 0 ? true : false,
    			autoplay: true,
    			speed: 1200,
    			autoplaySpeed: 4000,
	    		slidesToShow: 1
	    	});
    	}

    	pagination.remove();
    	btnPrev.remove();
    	btnNext.remove();
    });

    jQuery('.beans-fadeslider').each(function() {
    	var item = jQuery(this);
    	var btnPrev = item.find('.btn-prev');
    	var btnNext = item.find('.btn-next');
    	var slider = item.find('.slideset');
    	var pagination = item.find('.beans-pagination');

    	slider.slick({
    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
    		dots: pagination.length > 0 ? true : false,
    		pauseOnHover: false,
    		autoplay: true,
    		fade: true,
    		speed: 800
    	});

    	pagination.remove();
    	btnPrev.remove();
    	btnNext.remove();
    });

    jQuery('.beans-stepslider2').each(function() {
    	var item = jQuery(this);
    	var slider = item.find('.beans-slideset');

    	slider.slick({
    		asNavFor: '.beans-pagination ul',
    		pauseOnHover: false,
    		arrows: false,
    		speed: 800
    	});
    });

    jQuery('.beans-pagination').each(function() {
    	var item = jQuery(this);
    	var btnPrev = item.find('.btn-prev');
    	var btnNext = item.find('.btn-next');
    	var slider = item.find('ul');

    	slider.slick({
    		arrows: (btnPrev.length > 0) && (btnNext.length > 0) ? true : false,
    		asNavFor: '.beans-stepslider2 .beans-slideset',
    		focusOnSelect: true,
    		slidesToShow: 1,
    		mobileFirst: true,
    		autoplay: false,
    		responsive: [
    			{
    				breakpoint: 767,
    				settings: {
    					slidesToShow: 2
    				}
    			}, {
					breakpoint: 1024,
    				settings: {
    					slidesToShow: 4
    				}    				
    			}
    		]
    	});
    });
}


// NavRemoveClass init
function initNavRemoveClass() {
	jQuery("#nav .smoothanchor").click(function(){
		if (jQuery("body").hasClass("mainnav-active")) {
			setTimeout(function() { 
			jQuery("body").removeClass("mainnav-active");}, 1000);
		}
	});
}

 

// sticky header init
function initStickyHeader() {
	var win = jQuery(window),
		stickyClass = 'fixed-position';

	jQuery('#header').each(function() {
		var header = jQuery(this);
		var headerOffset = header.offset().top || 0;
		var flag = true;

		function scrollHandler() {
			if (win.scrollTop() > headerOffset) {
				if (flag){
					flag = false;
					header.addClass(stickyClass);
				}
			} else {
				if (!flag) {
					flag = true;
					header.removeClass(stickyClass);
				}
			}

		
		}

		scrollHandler();
		win.on('scroll resize orientationchange', scrollHandler);
	});
}

 

// animation init
function initJqureyAnimation() {
	var sections = jQuery('[data-animate]');
	var	pageBody = jQuery('body');

	sections.each(function() {
		var item = jQuery(this);
		var delay = item.attr('data-delay') ? Number(item.attr('data-delay')) + 500 : 500;
		var animation = item.attr('data-animate');

		if(!item.hasClass('animated')) {
			item.addClass('not-animated');
			item.appear(function () {
				setTimeout(function() {
					item.removeClass('not-animated').addClass(animation + ' animated');
				}, delay);
			},{accX: 0, accY: -120},'easeInCubic');
		}
	});
}


// flickr feed init
function initFlickrPhotos() {
	var flickrBox = jQuery('.flickr-feed');

	flickrBox.each(function() {
		var item = jQuery(this);
		var feedType = item.attr('data-type');

		item.jflickrfeed({
			feedapi: feedType === 'group' ? 'groups_pool.gne' : feedType,
			limit: Number(item.attr('data-count')) || 8,
			qstrings: {
				id: item.attr('data-id')
			},
			itemTemplate: '<a href="{{image_b}}" title="{{title}}" rel="lightbox">' + '<img src="{{image_s}}" alt="{{title}}" />' + '</a>'
		});
	});
}

// animate pie charts init
function initPieCharts() {
	if(typeof jQuery.fn.easyPieChart != 'undefined'){
		jQuery(".pie-chart:in-viewport").each(function() {
			var item = jQuery(this);
			var dimension = item.attr("data-barSize");

			item.css({
				'height': dimension,
				'width': dimension,
				'line-height': dimension + 'px'
			});
			
			item.easyPieChart({
				animate: 2000,
				lineCap: "square",
				lineWidth: item.attr("data-lineWidth"),
				size: dimension,
				barColor: item.attr("data-barColor"),
				trackColor: item.attr("data-trackColor"),
				scaleColor: "transparent",
				onStep: function(from, to, percent) {
					jQuery(this.el).find('.pie-chart-percent span').text(Math.round(from));
				}
			});
		});
	}
}

// progressbars init
function initAnimatedProgressbars() {
	jQuery(".progress-bar .progress-bar-outer:in-viewport").each(function() {
		var item = jQuery(this);
		var percent = item.attr('data-width');
		var animationSpeed = 2500;
		var flag = false;

		if(!flag) {
			item.animate({
				width: percent + "%"
			}, animationSpeed);

			flag = true;
		}
	});
}

// count down init
 

// counter init
function initNumCounter() {
	var counters = jQuery('.counter');
	var pageBody = jQuery('body');

	counters.each(function() {
		var item = jQuery(this);
		var isComma = item.find('span').attr('data-comma');

		item.appear(function() {
			if(isComma) {
				item.find('span').countTo({
					formatter: function (value, options) {
						value = value.toFixed(options.decimals);
						value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
						return value;
					}
				});
			} else {
				item.find('span').countTo();
			}
		});
	});
}

// go to top init
function initGoToTop() {
	var linkTop = jQuery('#gotoTop');
	var animationSpeed = 600;
	
	linkTop.click(function(e) {
		e.preventDefault();
		
		jQuery('body,html').stop(true).animate({
			scrollTop: 0
		}, animationSpeed);
	});
}

// go to top scroll init
function initGoToTopScroll() {
	var linkTop = jQuery('#gotoTop'),
		win = jQuery(window);
	
	if(win.scrollTop() > 0) {
		linkTop.fadeIn();
	} else {
		linkTop.fadeOut();
	}
}

// // PreLoader init
function initPreLoader() {
	jQuery('#pre-loader').delay(1200).fadeOut();
}

 

// VimeoPlayer init
function initVimeoPlayer() {
	var vimeoHolder = jQuery('.vimeo-area');

	vimeoHolder.each(function(index, item) {
		var container = jQuery(item);
		var vimeoBox = container.find('.vimeo');
		var iframe = jQuery('#player1')[0];
		var player = $f(iframe);
		var button = container.find('.btn-play');
		var activeClass = 'playing';

		window.setTimeout(function() {
			vimeoBox.css({
				visibility: 'visible'
			});
		}, 2000);

		player.addEvent('ready', function() {
			player.api('setVolume', 0);
			button.on('click', function(e) {
				e.preventDefault();

				if(button.hasClass(activeClass)) {
					player.api('pause');
					button.removeClass(activeClass);
				} else {
					player.api('play');
					button.addClass(activeClass);
				}
			});
		});
	});
}

// initVideoPlayer init
function initVideoPlayer() {
	jQuery('.video-area').each(function() {
		var container = jQuery(this);
		var player = container.find('video').mediaelementplayer().get(0);
		var button = container.find('.btn-play');
		var activeClass = 'playing';
		
		
		if(container.hasClass('mute')) {
		   player.setVolume(0);
		}
		button.on('click', function(e) {
			e.preventDefault();
			
			if(button.hasClass(activeClass)) {
				player.pause();
				button.removeClass(activeClass);
			} else {
				player.play();
				button.addClass(activeClass);
			}
		});
	});
}

// GoogleMap init
 
 

// style changer
function initStyleChanger() {
	var element = jQuery('#style-changer');

	if(element) {
		$.ajax({
			url: element.attr('data-src'),
			type: 'get',
			dataType: 'text',
			success: function(data) {
				var newContent = jQuery('<div>', {
					html: data
				});

				newContent.appendTo(element);
				jQuery('body').mobileNav({
					hideOnClickOutside: false,
					menuActiveClass: 'changer-active',
					menuOpener: '.changer-opener'
				});
				jQuery('body').mobileNav({
					hideOnClickOutside: false,
					menuActiveClass: 'boxed-v',
					menuOpener: '.boxed-link, .btn2',
					onInit: function() {
						
						initBackgroundResize();
					},
					onHide: function() {
						
						initBackgroundResize();
					}
				});
				
				var sheet,
					darkSheet,
					sheetName,
					darkSheetName = 'dark',
					sheetAdded = false,
					darkStylesAdded = false;

				jQuery('.list-color li').each(function() {
					var item = jQuery(this),
						link = item.find('a').eq(0);

					link.on('click', function(e) {
						e.preventDefault();
						sheetName = item.attr('class');

						if(!sheetAdded) {
							sheet = jQuery('<link>').attr('rel','stylesheet')
										.attr('type','text/css')
										.attr('href', 'css/color/' + sheetName + '.css')
										.appendTo('head');

							sheetAdded = true;
						} else {
							sheet.attr('href', 'css/color/' + sheetName + '.css');
						}
					});
				});
				jQuery('.list-bg-color li').each(function() {
					var body = jQuery('body'),
						item = jQuery(this),
						link = item.find('a').eq(0);
										 
					link.on('click', function(e) {
						e.preventDefault();
						
						body.removeClass('dark');
						if(link.hasClass('dark')) {
							if(!body.hasClass('dark')) {
								body.addClass('dark');
							}
						}
					});
				});
			}
		});
	}
}

// initialize smooth anchor links


// content tabs init
function initTabs() {
	jQuery('ul.beans-tabset').contentTabs({
		addToParent: true,
		tabLinks: 'a'
	});
	jQuery('ul.tabset').contentTabs({
		addToParent: true,
		tabLinks: 'a'
	});
	jQuery('ul.tabset-onepage').contentTabs({
		addToParent: true,
		tabLinks: 'a'
	});
}

 

// init youtube background player
function initYoutubePlayer() {
	jQuery(".youtube_bg_video").each(function() {
		var player = jQuery(this),
			btnPlay = player.closest('.video-section').find('.play-icon'),
			videoPlaying = false;
			player.YTPlayer();

		btnPlay.on('click', function(e) {
			e.preventDefault();
			if(videoPlaying) {
				player.pauseYTP();
				btnPlay.removeClass('video-playing').addClass('video-pause');
				videoPlaying = false;
			} else {
				player.playYTP();
				btnPlay.removeClass('video-pause').addClass('video-playing');
				videoPlaying = true;
			}
		});
	});
}

 

// ajax load init
function initAjaxLoad(){
	jQuery('.ajax-area').ajaxPopup({
		button: '.btn-load',
		ajaxHold: '#ajax-holder',
		appendToBody: false,
		attr: 'href',
	 	animSpeed: 500,
	 	onChange: function(){
	 		//initCycleCarousel();
	 		initBackgroundResize();
	 	}
	});
}

// mobile menu init
function initMobileNav() {
	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'sidenav-active',
		menuOpener: '.menu-opener , .btn-close',
		menuDrop: '.menu-nav'
	});
	jQuery('body').mobileNav({
		hideOnClickOutside: false,
		menuActiveClass: 'search-active',
		menuOpener: '.search-opener , .close-btn'
	});
	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'mainnav-active',
		menuOpener: '.nav-opener',
		menuDrop: '.sidemenu-photo, .nav-holder'
	});
	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'mainnav-active',
		menuOpener: '.main-navopener2',
		menuDrop: '.main-menu'
	});
	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'nav-active',
		menuOpener: '.portfolio-nav-opener',
		menuDrop: '.sidenav-port'
	});
}

// dropdown classes
function initHasDropClasses() {
	var dropClassName = 'has-drop',
		megaDropClassName = 'has-mega-drop';

	jQuery('#nav li').each(function(index, item) {
		var container = jQuery(item),
			link = container.find('a'),
			drop = container.find('.drop'),
			megaDrop = container.find('.mega-drop');

		if(drop.length) {
			container.addClass(dropClassName);
		}

		if(megaDrop.length) {
			container.addClass(megaDropClassName);
		}
	});
}

// initialize Parallax background
function initParallaxBg() {
	jQuery('.parallax-holder').parallaxBG({
		parent: '.parallax-frame',
		image: 'img',
		parallaxOffset: 100,
		fallbackFunc: initBgStretch
	});
}

// stretch background to fill blocks
function initBackgroundResize() {
	jQuery('.stretch').each(function() {
		ImageStretcher.add({
			container: this,
			image: 'img'
		});
	});
}

// running line init
function initMarquee() {
	jQuery('.line-box').marquee({
		line: '.line',
		animSpeed: 50
	});
}

 

 

// accordion menu init
function initAccordion() {
	jQuery('.blog-accordion').slideAccordion({
		opener: 'a.opener',
		slider: '.blog-slide',
		animSpeed: 300
	});
	jQuery('.beans-accordion').slideAccordion({
		opener: 'a.opener',
		slider: '.beans-slide',
		animSpeed: 300
	});
}

// form validation init
function initFormValidation() {
	//if submit button is clicked
	$('#submit,#submit2').click(function () {

        //Get the data from all the fields
        var name = $('input[name=name]');
        var email = $('input[name=email]');
        var website = $('input[name=website]');
        var comment = $('textarea[name=comment]');
        var returnError = false;

        //Simple validation to make sure user entered something
        //Add your own error checking here with JS, but also do some error checking with PHP.
        //If error found, add hightlight class to the text field
        if (name.val()=='') {
            name.addClass('error');
            returnError = true;
        } else name.removeClass('error');

        if (email.val()=='') {
            email.addClass('error');
            returnError = true;
        } else email.removeClass('error');

        if (comment.val()=='') {
            comment.addClass('error');
            returnError = true;
        } else comment.removeClass('error');

        // Highlight all error fields, then quit.
        if(returnError == true) {
            return false;	
        }

        //organize the data
        var data = 'name=' + name.val() + '&email=' + email.val() + '&website=' + website.val() + '&comment='  + encodeURIComponent(comment.val());

        //disabled all the text fields
        $('.text').attr('disabled','true');

        //show the loading sign
        $('.loading').show();

        //start the ajax
        $.ajax({
            //this is the php file that processes the data and sends email
            url: "inc/process.php",	

            //GET method is used
            type: "GET",

            //pass the data	
            data: data,	

            //Do not cache the page
            cache: false,

            //success
            success: function (html) {	
            //if process.php returned 1/true (send mail success)
                if (html==1) {	
                //hide the form
                $('.email-form').fadeOut('slow');	

                //show the success message
                $('.done-massage').fadeIn('slow');

                //if process.php returned 0/false (send mail failed)
                } else alert('Sorry, unexpected error. Please try again later.');	
            }	
        });

        //cancel the submit button default behaviours
        return false;
	});
	//if submit button is clicked
	$('#form-submit').click(function () {

        //Get the data from all the fields
        var name = $('input[name=name]');
        var email = $('input[name=email]');
        var purchase = $('input[name=purchase]');
        var profile = $('input[name=profile]');
        var comment = $('textarea[name=comment]');
        var returnError = false;

        //Simple validation to make sure user entered something
        //Add your own error checking here with JS, but also do some error checking with PHP.
        //If error found, add hightlight class to the text field
        if (name.val()=='') {
            name.addClass('error');
            returnError = true;
        } else name.removeClass('error');

        if (email.val()=='') {
            email.addClass('error');
            returnError = true;
        } else email.removeClass('error');

        if (purchase.val()=='') {
            purchase.addClass('error');
            returnError = true;
        } else purchase.removeClass('error');

        if (profile.val()=='') {
            profile.addClass('error');
            returnError = true;
        } else profile.removeClass('error');

        if (comment.val()=='') {
            comment.addClass('error');
            returnError = true;
        } else comment.removeClass('error');

        // Highlight all error fields, then quit.
        if(returnError == true) {
            return false;	
        }

        //organize the data
        var data = 'name=' + name.val() + '&email=' + email.val() + '&purchase=' + purchase.val() + '&profile=' + profile.val() + '&website=' + website.val() + '&comment='  + encodeURIComponent(comment.val());

        //disabled all the text fields
        $('.form-control').attr('disabled','true');

        //show the loading sign
        $('.loading').show();

        //start the ajax
        $.ajax({
            //this is the php file that processes the data and sends email
            url: "inc/process2.php",	

            //GET method is used
            type: "GET",

            //pass the data	
            data: data,	

            //Do not cache the page
            cache: false,

            //success
            success: function (html) {	
            //if process.php returned 1/true (send mail success)
                if (html==1) {	
                //hide the form
                $('.email-form').fadeOut('slow');	

                //show the success message
                $('.done-massage').fadeIn('slow');

                //if process.php returned 0/false (send mail failed)
                } else alert('Sorry, unexpected error. Please try again later.');	
            }	
        });

        //cancel the submit button default behaviours
        return false;
	});
}


/*
 * Simple Mobile Navigation
 */
;(function($) {
	function MobileNav(options) {
		this.options = $.extend({
			container: null,
			hideOnClickOutside: false,
			menuActiveClass: 'nav-active',
			menuOpener: '.nav-opener',
			menuDrop: '.nav-drop',
			toggleEvent: 'click',
			outsideClickEvent: 'click touchstart pointerdown MSPointerDown'
		}, options);
		this.initStructure();
		this.attachEvents();
	}
	MobileNav.prototype = {
		initStructure: function() {
			this.page = $('html');
			this.container = $(this.options.container);
			this.opener = this.container.find(this.options.menuOpener);
			this.drop = this.container.find(this.options.menuDrop);
		},
		attachEvents: function() {
			var self = this;

			if(activateResizeHandler) {
				activateResizeHandler();
				activateResizeHandler = null;
			}

			this.outsideClickHandler = function(e) {
				if(self.isOpened()) {
					var target = $(e.target);
					if(!target.closest(self.opener).length && !target.closest(self.drop).length) {
						self.hide();
					}
				}
			};

			this.openerClickHandler = function(e) {
				e.preventDefault();
				self.toggle();
			};

			this.opener.on(this.options.toggleEvent, this.openerClickHandler);
		},
		isOpened: function() {
			return this.container.hasClass(this.options.menuActiveClass);
		},
		show: function() {
			this.container.addClass(this.options.menuActiveClass);
			if(this.options.hideOnClickOutside) {
				this.page.on(this.options.outsideClickEvent, this.outsideClickHandler);
			}
			this.makeCallback('onInit', this);
		},
		hide: function() {
			this.container.removeClass(this.options.menuActiveClass);
			if(this.options.hideOnClickOutside) {
				this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
			}
			this.makeCallback('onHide', this);
		},
		toggle: function() {
			if(this.isOpened()) {
				this.hide();
			} else {
				this.show();
			}
		},
		makeCallback: function(name) {
			if(typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		},
		destroy: function() {
			this.container.removeClass(this.options.menuActiveClass);
			this.opener.off(this.options.toggleEvent, this.clickHandler);
			this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
		}
	};

	var activateResizeHandler = function() {
		var win = $(window),
			doc = $('html'),
			resizeClass = 'resize-active',
			flag, timer;
		var removeClassHandler = function() {
			flag = false;
			doc.removeClass(resizeClass);
		};
		var resizeHandler = function() {
			if(!flag) {
				flag = true;
				doc.addClass(resizeClass);
			}
			clearTimeout(timer);
			timer = setTimeout(removeClassHandler, 500);
		};
		win.on('resize orientationchange', resizeHandler);
	};

	$.fn.mobileNav = function(options) {
		return this.each(function() {
			var params = $.extend({}, options, {container: this}),
				instance = new MobileNav(params);
			$.data(this, 'MobileNav', instance);
		});
	};
}(jQuery));


;(function($){
	function ParallaxBG(opt) {
		this.options = $.extend({
			parent: '.bg-frame',
			image: 'img',
			parallaxOffset: 100,
			fallbackFunc: function() {}
		}, opt);
		this.init();
	}
	ParallaxBG.prototype = {
		init: function() {
			if(this.options.holder) {
				if(typeof this.options.fallbackFunc == 'function' && (oldIe || isTouchDevice)) {
					this.options.fallbackFunc();
					return;
				}
				this.getStructure();
				this.attachEvents();
			}
		},
		getStructure: function() {
			this.holder = $(this.options.holder);
			this.parent = this.holder.find(this.options.parent);
			this.holderHeight = this.holder.height();
			this.holderOffset = this.holder.offset().top;

			// generate bg
			this.image = this.parent.find(this.options.image).eq(0).css({visibility: 'hidden'});
			this.imageRatio = this.image.attr('width')/this.image.attr('height') || this.image.width()/this.image.height();

			this.parent.css({
				backgroundImage: 'url('+this.image.attr('src')+')',
				backgroundRepeat: 'no-repeat',
				backgroundAttachment: 'fixed'
			});

			this.win = $(window);
			this.winHeight = this.win.height();
			this.winWidth = this.win.width();
			this.winScroll = this.win.scrollTop();
			this.bgHeight = this.winHeight + this.options.parallaxOffset;
		},
		attachEvents: function() {
			var self = this;
			this.bindHandlers(['scrollLayout']);
			this.bindHandlers(['resizeLayout']);
			this.win.bind('scroll', this.scrollLayout).bind('resize load', this.resizeLayout);

			// fix load problem
			setTimeout(function() {
				self.resizeLayout();
				self.win.trigger('scroll');
			}, 500);
		},
		resizeLayout: function() {
			// get dimensions
			this.winHeight = this.win.height();
			this.winWidth = this.win.width();
			this.holderHeight = this.holder.height();
			this.holderOffset = this.holder.offset().top;
			
			this.blockHeight = this.winHeight + this.options.parallaxOffset;
			this.currentTop = Math.max(0, this.blockHeight - this.holderHeight);

			// get parallax ratio and image ratio state
			this.parallaxRatio = this.win.width()/(this.winHeight + this.options.parallaxOffset);
			this.ratioState = this.imageRatio <= this.parallaxRatio;
			
			if(this.ratioState) {
				this.bgWidth = this.winWidth;
				this.bgHeight = this.bgWidth/this.imageRatio;
			} else {
				this.bgWidth = 'auto';
				this.bgHeight = this.winHeight + this.options.parallaxOffset;
			}

			this.parent.css({
				paddingBottom: this.currentTop,
				backgroundSize: this.bgWidth != 'auto' ? this.bgWidth +'px '+this.bgHeight+'px' : this.bgWidth +' '+this.bgHeight+'px'
			});
			this.scrollLayout();
		},
		scrollLayout: function() {
			this.winScroll = this.win.scrollTop();
			this.offsetPercentage = Math.max(0, Math.min((this.winScroll + this.winHeight - this.holderOffset)/(this.winHeight + this.holderHeight), 1)).toFixed(4);

			if(!!this.ratioState) {
				var curPos = '50% ' + ((-parseFloat(this.offsetPercentage)*this.options.parallaxOffset) - (this.bgHeight - this.winHeight)/2)+'px';
			} else {
				var curPos = '50% ' + (-parseFloat(this.offsetPercentage)*this.options.parallaxOffset)+'px';
			}

			this.parent.css({backgroundPosition: curPos});
		},
		bindHandlers: function(handlersList) {
			var self = this;
			$.each(handlersList, function(index, handler) {
				var origHandler = self[handler];
				self[handler] = function() {
					return origHandler.apply(self, arguments);
				};
			});
		}
	};

	// detect device type
	var isTouchDevice = /MSIE 10.*Touch/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
	var oldIe = window.attachEvent && !window.addEventListener;

	// jquery parallax plugin
	$.fn.parallaxBG = function(opt){
		return this.each(function(){
			new ParallaxBG($.extend(opt,{holder:this}));
		});
	};
}(jQuery));

// background stretching
function initBgStretch() {
	jQuery('.bg-frame').each(function() {
		var holder = jQuery(this);
		var image = holder.find('img');
		jQuery(window).bind('load resize', function() {
			var settings = getProportions(getDimensions(image, holder));
			resizeAll(image, settings);	
		});
	});

	function getProportions(dimensions) {
		var ratio = dimensions.ratio || (dimensions.elementWidth / dimensions.elementHeight);
		var slideWidth = dimensions.maskWidth, slideHeight = slideWidth / ratio;
		if(slideHeight < dimensions.maskHeight) {
			slideHeight = dimensions.maskHeight;
			slideWidth = slideHeight * ratio;
		}
		return {
			width: slideWidth,
			height: slideHeight,
			top: (dimensions.maskHeight - slideHeight) / 2,
			left: (dimensions.maskWidth - slideWidth) / 2
		}
	}
	
	function getDimensions(img, block) {
		img.css({
			height: '',
			left: '',
			top: '',
			width: ''
		});
		return {
			ratio: img.width()/img.height(),
			maskWidth: block.width(),
			maskHeight: block.outerHeight(true)
		};
	}

	function resizeAll(img, obj) {
		img.css({
			height: obj.height,
			left: obj.left,
			top: obj.top,
			width: obj.width
		});
	}
}


/*
 * Image Stretch module
 */
var ImageStretcher = {
	getDimensions: function(data) {
		// calculate element coords to fit in mask
		var ratio = data.imageRatio || (data.imageWidth / data.imageHeight),
			slideWidth = data.maskWidth,
			slideHeight = slideWidth / ratio;

		if(slideHeight < data.maskHeight) {
			slideHeight = data.maskHeight;
			slideWidth = slideHeight * ratio;
		}
		return {
			width: slideWidth,
			height: slideHeight,
			top: (data.maskHeight - slideHeight) / 2,
			left: (data.maskWidth - slideWidth) / 2
		};
	},
	getRatio: function(image) {
		if(image.prop('naturalWidth')) {
			return image.prop('naturalWidth') / image.prop('naturalHeight');
		} else {
			var img = new Image();
			img.src = image.prop('src');
			return img.width / img.height;
		}
	},
	imageLoaded: function(image, callback) {
		var self = this;
		var loadHandler = function() {
			callback.call(self);
		};
		if(image.prop('complete')) {
			loadHandler();
		} else {
			image.one('load', loadHandler);
		}
	},
	resizeHandler: function() {
		var self = this;
		jQuery.each(this.imgList, function(index, item) {
			if(item.image.prop('complete')) {
				self.resizeImage(item.image, item.container);
			}
		});
	},
	resizeImage: function(image, container) {
		this.imageLoaded(image, function() {
			var styles = this.getDimensions({
				imageRatio: this.getRatio(image),
				maskWidth: container.width(),
				maskHeight: container.height()
			});
			image.css({
				width: styles.width,
				height: styles.height,
				marginTop: styles.top,
				marginLeft: styles.left
			});
		});
	},
	add: function(options) {
		var container = jQuery(options.container ? options.container : window),
			image = typeof options.image === 'string' ? container.find(options.image) : jQuery(options.image);

		// resize image
		this.resizeImage(image, container);

		// add resize handler once if needed
		if(!this.win) {
			this.resizeHandler = jQuery.proxy(this.resizeHandler, this);
			this.imgList = [];
			this.win = jQuery(window);
			this.win.on('resize orientationchange', this.resizeHandler);
		}

		// store item in collection
		this.imgList.push({
			container: container,
			image: image
		});
	}
};




/*
 * jQuery SlideMenu plugin
 */
;(function($){
	function AjaxPopup(options){
		this.options = $.extend({
			holder: null,
			button: '.btn-more',
			holderBox: 'body',
			ajaxHold: '#ajax-holder',
			appendToBody: false,
			attr: 'href',
			animSpeed: 500
		}, options);

		this.init();
	}
	AjaxPopup.prototype = {
		init: function(){
			this.findElements();
			this.makeCallback('onInit', this);
			this.attachEvents();
		},
		findElements: function(){
			this.holder = jQuery(this.options.holder);
			this.button = this.holder.find(this.options.button);
			this.ajaxHold = this.holder.find(this.options.ajaxHold);

		},
		attachEvents: function(){
			var self = this;
			this.clickHandler = function(e){
				e.preventDefault();
				var attr = self.button.attr(self.options.attr);
				if(attr != '#'){
					e.preventDefault();
					self.ajaxLoad(attr).done(function(data){
						var content = jQuery(data).filter('.blogs-block').css({opacity: 0});
						var btnAjax = jQuery(data).filter('.btn-load');

						if(self.options.appendToBody) content.appendTo(jQuery(self.options.holderBox));
						else content.appendTo(self.ajaxHold);

						if(btnAjax.length) self.button.attr('href', btnAjax.attr('href')); 
						else self.button.hide();
					
						content.stop().animate({opacity: 1}, self.options.animSpeed);
						self.makeCallback('onChange', self);
					});
				}
			};
			this.button.on('click', this.clickHandler);
		},
		ajaxLoad: function(url){
			var d = jQuery.Deferred();
			jQuery.ajax({
				url: url,
				type: 'get',
				cache: false,
				dataType: "html",
				success: function(data){
					d.resolve(data);
				},
				error: function(jqXHR, textStatus, errorThrown){
					d.reject(jqXHR, textStatus, errorThrown);
				}
			});
			return d;
		},
		makeCallback: function(name) {
			if(typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
					args.shift();
					this.options[name].apply(this, args);
				}
			}
		};

	$.fn.ajaxPopup = function(options){
		return this.each(function(){
			$(this).data('AjaxPopup', new AjaxPopup($.extend(options, {holder:this})));
		});
	};
})(jQuery);

/*
 * jQuery Accordion plugin
 */
;(function($){
	$.fn.slideAccordion = function(opt){
		// default options
		var options = $.extend({
			addClassBeforeAnimation: false,
			allowClickWhenExpanded: false,
			activeClass:'active',
			opener:'.opener',
			slider:'.slide',
			animSpeed: 300,
			collapsible:true,
			event:'click'
		},opt);

		return this.each(function(){
			// options
			var accordion = $(this);
			var items = accordion.find(':has('+options.slider+')');

			items.each(function(){
				var item = $(this);
				var opener = item.find(options.opener);
				var slider = item.find(options.slider);
				opener.bind(options.event, function(e){
					if(!slider.is(':animated')) {
						if(item.hasClass(options.activeClass)) {
							if(options.allowClickWhenExpanded) {
								return;
							} else if(options.collapsible) {
								slider.slideUp(options.animSpeed, function(){
									hideSlide(slider);
									item.removeClass(options.activeClass);
								});
							}
						} else {
							// show active
							var levelItems = item.siblings('.'+options.activeClass);
							var sliderElements = levelItems.find(options.slider);
							item.addClass(options.activeClass);
							showSlide(slider).hide().slideDown(options.animSpeed);
						
							// collapse others
							sliderElements.slideUp(options.animSpeed, function(){
								levelItems.removeClass(options.activeClass);
								hideSlide(sliderElements);
							});
						}
					}
					e.preventDefault();
				});
				if(item.hasClass(options.activeClass)) showSlide(slider); else hideSlide(slider);
			});
		});
	};

	// accordion slide visibility
	var showSlide = function(slide) {
		return slide.css({position:'', top: '', left: '', width: '' });
	};
	var hideSlide = function(slide) {
		return slide.show().css({position:'absolute', top: -9999, left: -9999, width: slide.width() });
	};
}(jQuery));

/*
 * jQuery <marquee> plugin
 */
;(function($){
	function Marquee(options) {
		this.options = $.extend({
			holder: null,
			handleFlexible: true,
			pauseOnHover: true,
			hoverClass: 'hover',
			direction: 'left',
			cloneClass: 'cloned',
			mask: null,
			line: '>*',
			items: '>*',
			animSpeed: 10, // px per second
			initialDelay: 0
		}, options);
		this.init();
	}
	Marquee.prototype = {
		init: function() {
			if(this.options.holder) {
				this.initStructure();
				this.attachEvents();
			}
		},
		initStructure: function() {
			// find elements
			this.holder = $(this.options.holder);
			this.mask = this.options.mask ? this.holder.find(this.options.mask) : this.holder,
			this.line = this.mask.find(this.options.line),
			this.items = this.line.find(this.options.items).css({'float':'left'});
			this.direction = (this.options.direction === 'left') ? -1 : 1;
			this.recalculateDimensions();

			// prepare structure
			this.cloneItems = this.items.clone().addClass(this.options.cloneClass).appendTo(this.line);
			if(this.itemWidth >= this.maskWidth) {
				this.activeLine = true;
				this.offset = (this.direction === -1 ? 0 : this.maxOffset);
			} else {
				this.activeLine = false;
				this.cloneItems.hide();
				this.offset = 0;
			}
			this.line.css({
				width: this.itemWidth * 2,
				marginLeft: this.offset
			});
		},
		attachEvents: function() {
			// flexible layout handling
			var self = this;
			if(this.options.handleFlexible) {
				this.resizeHandler = function() {
					self.recalculateDimensions();
					if(self.itemWidth < self.maskWidth) {
						self.activeLine = false;
						self.cloneItems.hide();
						self.stopMoving();
						self.offset = 0;
						self.line.css({marginLeft: self.offset});
					} else {
						self.activeLine = true;
						self.cloneItems.show();
						self.startMoving();
					}
				};
				$(window).bind('resize orientationchange', this.resizeHandler);
			}

			// pause on hover
			if(this.options.pauseOnHover) {
				this.hoverHandler = function() {
					self.stopMoving();
					self.holder.addClass(self.options.hoverClass);
				};
				this.leaveHandler = function() {
					self.startMoving();
					self.holder.removeClass(self.options.hoverClass);
				};
				this.holder.bind({ mouseenter: this.hoverHandler, mouseleave: this.leaveHandler });
			}

			// initial delay
			setTimeout(function(){
				self.initialFlag = true;
				self.startMoving();
			}, self.options.initialDelay || 1);
		},
		recalculateDimensions: function() {
			// calculate block dimensions
			var self = this;
			this.maskWidth = this.mask.width();
			this.itemWidth = 1;
			this.items.each(function(){
				self.itemWidth += $(this).outerWidth(true);
			});
			this.maxOffset = -this.itemWidth;
		},
		startMoving: function() {
			// start animation
			var self = this;
			if(self.activeLine && self.initialFlag) {
				var targetOffset = (self.direction < 0 ? self.maxOffset : 0);

				self.offset = parseInt(self.line.css('marginLeft'), 10) || 0;
				self.line.stop().animate({
					marginLeft: targetOffset
				}, {
					duration: Math.abs(1000 * (self.offset - targetOffset) / self.options.animSpeed),
					easing: 'linear',
					complete: function() {
						self.offset = (self.direction < 0 ? 0 : self.maxOffset);
						self.line.css({marginLeft: self.offset});
						self.startMoving();
					}
				});
			}
		},
		stopMoving: function() {
			// stop animation
			this.line.stop();
		},
		destroy: function() {
			this.stopMoving();
			this.cloneItems.remove();
			this.items.css({'float':''});
			this.line.css({marginLeft:'',width:''});
			this.holder.removeClass(this.options.hoverClass);
			this.holder.unbind('mouseenter', this.hoverHandler);
			this.holder.unbind('mouseleave', this.leaveHandler);
			$(window).unbind('resize orientationchange', this.resizeHandler);
		}
	};

	// jQuery plugin interface
	$.fn.marquee = function(opt) {
		return this.each(function() {
			jQuery(this).data('Marquee', new Marquee($.extend(opt, {holder: this})));
		});
	};
}(jQuery));





 

 

/*
 * jQuery Tabs plugin
 */
;(function($){
	$.fn.contentTabs = function(o){
		// default options
		var options = $.extend({
			activeClass:'active',
			addToParent:false,
			autoHeight:false,
			autoRotate:false,
			checkHash:false,
			animSpeed:400,
			switchTime:3000,
			effect: 'none', // "fade", "slide"
			tabLinks:'a',
			attrib:'href',
			event:'click'
		},o);

		return this.each(function(){
			var tabset = $(this), tabs = $();
			var tabLinks = tabset.find(options.tabLinks);
			var tabLinksParents = tabLinks.parent();
			var prevActiveLink = tabLinks.eq(0), currentTab, animating;
			var tabHolder;

			// handle location hash
			if(options.checkHash && tabLinks.filter('[' + options.attrib + '="' + location.hash + '"]').length) {
				(options.addToParent ? tabLinksParents : tabLinks).removeClass(options.activeClass);
				setTimeout(function() {
					window.scrollTo(0,0);
				},1);
			}

			// init tabLinks
			tabLinks.each(function(){
				var link = $(this);
				var href = link.attr(options.attrib);
				var parent = link.parent();
				href = href.substr(href.lastIndexOf('#'));

				// get elements
				var tab = $(href).hide().addClass(tabHiddenClass);
				tabs = tabs.add(tab);
				link.data('cparent', parent);
				link.data('ctab', tab);

				// find tab holder
				if(!tabHolder && tab.length) {
					tabHolder = tab.parent();
				}

				// show only active tab
				var classOwner = options.addToParent ? parent : link;
				if(classOwner.hasClass(options.activeClass) || (options.checkHash && location.hash === href)) {
					classOwner.addClass(options.activeClass);
					prevActiveLink = link; currentTab = tab;
					tab.removeClass(tabHiddenClass).width('');
					contentTabsEffect[options.effect].show({tab:tab, fast:true});
				} else {
					var tabWidth = tab.width();
					if(tabWidth) {
						tab.width(tabWidth);
					}
					tab.addClass(tabHiddenClass);
				}

				// event handler
				link.bind(options.event, function(e){
					if(link != prevActiveLink && !animating) {
						switchTab(prevActiveLink, link);
						prevActiveLink = link;
					}
				});
				if(options.attrib === 'href') {
					link.bind('click', function(e){
						e.preventDefault();
					});
				}
			});

			// tab switch function
			function switchTab(oldLink, newLink) {
				animating = true;
				var oldTab = oldLink.data('ctab');
				var newTab = newLink.data('ctab');
				prevActiveLink = newLink;
				currentTab = newTab;

				// refresh pagination links
				(options.addToParent ? tabLinksParents : tabLinks).removeClass(options.activeClass);
				(options.addToParent ? newLink.data('cparent') : newLink).addClass(options.activeClass);

				// hide old tab
				resizeHolder(oldTab, true);
				contentTabsEffect[options.effect].hide({
					speed: options.animSpeed,
					tab:oldTab,
					complete: function() {
						// show current tab
						resizeHolder(newTab.removeClass(tabHiddenClass).width(''));
						contentTabsEffect[options.effect].show({
							speed: options.animSpeed,
							tab:newTab,
							complete: function() {
								if(!oldTab.is(newTab)) {
									oldTab.width(oldTab.width()).addClass(tabHiddenClass);
								}
								animating = false;
								resizeHolder(newTab, false);
								autoRotate();
								$(window).trigger('resize');
							}
						});
					}
				});
			}

			// holder auto height
			function resizeHolder(block, state) {
				var curBlock = block && block.length ? block : currentTab;
				if(options.autoHeight && curBlock) {
					tabHolder.stop();
					if(state === false) {
						tabHolder.css({height:''});
					} else {
						var origStyles = curBlock.attr('style');
						curBlock.show().css({width:curBlock.width()});
						var tabHeight = curBlock.outerHeight(true);
						if(!origStyles) curBlock.removeAttr('style'); else curBlock.attr('style', origStyles);
						if(state === true) {
							tabHolder.css({height: tabHeight});
						} else {
							tabHolder.animate({height: tabHeight}, {duration: options.animSpeed});
						}
					}
				}
			}
			if(options.autoHeight) {
				$(window).bind('resize orientationchange', function(){
					tabs.not(currentTab).removeClass(tabHiddenClass).show().each(function(){
						var tab = jQuery(this), tabWidth = tab.css({width:''}).width();
						if(tabWidth) {
							tab.width(tabWidth);
						}
					}).hide().addClass(tabHiddenClass);

					resizeHolder(currentTab, false);
				});
			}

			// autorotation handling
			var rotationTimer;
			function nextTab() {
				var activeItem = (options.addToParent ? tabLinksParents : tabLinks).filter('.' + options.activeClass);
				var activeIndex = (options.addToParent ? tabLinksParents : tabLinks).index(activeItem);
				var newLink = tabLinks.eq(activeIndex < tabLinks.length - 1 ? activeIndex + 1 : 0);
				prevActiveLink = tabLinks.eq(activeIndex);
				switchTab(prevActiveLink, newLink);
			}
			function autoRotate() {
				if(options.autoRotate && tabLinks.length > 1) {
					clearTimeout(rotationTimer);
					rotationTimer = setTimeout(function() {
						if(!animating) {
							nextTab();
						} else {
							autoRotate();
						}
					}, options.switchTime);
				}
			}
			autoRotate();
		});
	};

	// add stylesheet for tabs on DOMReady
	var tabHiddenClass = 'js-tab-hidden';
	(function() {
		var tabStyleSheet = $('<style type="text/css">')[0];
		var tabStyleRule = '.'+tabHiddenClass;
		tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}';
		if (tabStyleSheet.styleSheet) {
			tabStyleSheet.styleSheet.cssText = tabStyleRule;
		} else {
			tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
		}
		$('head').append(tabStyleSheet);
	}());

	// tab switch effects
	var contentTabsEffect = {
		none: {
			show: function(o) {
				o.tab.css({display:'block'});
				if(o.complete) o.complete();
			},
			hide: function(o) {
				o.tab.css({display:'none'});
				if(o.complete) o.complete();
			}
		},
		fade: {
			show: function(o) {
				if(o.fast) o.speed = 1;
				o.tab.fadeIn(o.speed);
				if(o.complete) setTimeout(o.complete, o.speed);
			},
			hide: function(o) {
				if(o.fast) o.speed = 1;
				o.tab.fadeOut(o.speed);
				if(o.complete) setTimeout(o.complete, o.speed);
			}
		},
		slide: {
			show: function(o) {
				var tabHeight = o.tab.show().css({width:o.tab.width()}).outerHeight(true);
				var tmpWrap = $('<div class="effect-div">').insertBefore(o.tab).append(o.tab);
				tmpWrap.css({width:'100%', overflow:'hidden', position:'relative'}); o.tab.css({marginTop:-tabHeight,display:'block'});
				if(o.fast) o.speed = 1;
				o.tab.animate({marginTop: 0}, {duration: o.speed, complete: function(){
					o.tab.css({marginTop: '', width: ''}).insertBefore(tmpWrap);
					tmpWrap.remove();
					if(o.complete) o.complete();
				}});
			},
			hide: function(o) {
				var tabHeight = o.tab.show().css({width:o.tab.width()}).outerHeight(true);
				var tmpWrap = $('<div class="effect-div">').insertBefore(o.tab).append(o.tab);
				tmpWrap.css({width:'100%', overflow:'hidden', position:'relative'});

				if(o.fast) o.speed = 1;
				o.tab.animate({marginTop: -tabHeight}, {duration: o.speed, complete: function(){
					o.tab.css({display:'none', marginTop:'', width:''}).insertBefore(tmpWrap);
					tmpWrap.remove();
					if(o.complete) o.complete();
				}});
			}
		}
	};
}(jQuery));

 

//require("custom/checkout")

/*! lazysizes - v5.3.2 */

!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",fastLoadedClass:"ls-is-cached",iframeLoadMode:0,srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,i=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,o=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],a={},G=Array.prototype.forEach,J=function(e,t){if(!a[t]){a[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return a[t].test(e[$]("class")||"")&&a[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var a;if(a=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(a," "))}},V=function(t,a,e){var i=e?P:"removeEventListener";if(e){V(t,a)}r.forEach(function(e){t[i](e,a)})},X=function(e,t,a,i,r){var n=D.createEvent("Event");if(!a){a={}}a.instance=k;n.initEvent(t,!i,!r);n.detail=a;e.dispatchEvent(n);return n},Y=function(e,t){var a;if(!i&&(a=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}a({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,a){a=a||e.offsetWidth;while(a<H.minSize&&t&&!e._lazysizesWidth){a=t.offsetWidth;t=t.parentNode}return a},ee=function(){var a,i;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;a=true;i=false;while(e.length){e.shift()()}a=false};var e=function(e,t){if(a&&!t){e.apply(this,arguments)}else{n.push(e);if(!i){i=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(a,e){return e?function(){ee(a)}:function(){var e=this;var t=arguments;ee(function(){a.apply(e,t)})}},ae=function(e){var a;var i=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){a=false;i=f.now();e()};var s=o&&n>49?function(){o(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(a){return}a=true;t=r-(f.now()-i);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ie=function(e){var t,a;var i=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-a;if(e<i){I(n,i-e)}else{(o||r)(r)}};return function(){a=f.now();if(!t){t=I(n,i)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var M=0;var N=-1;var L=function(e){M--;if(!e||M<0||!e.target){M=0}};var x=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var W=function(e,t){var a;var i=e;var r=x(e);g-=t;b+=t;p-=t;C+=t;while(r&&(i=i.offsetParent)&&i!=D.body&&i!=O){r=(Z(i,"opacity")||1)>0;if(r&&Z(i,"overflow")!="visible"){a=i.getBoundingClientRect();r=C>a.left&&p<a.right&&b>a.top-1&&g<a.bottom+1}}return r};var t=function(){var e,t,a,i,r,n,s,o,l,u,f,c;var d=k.elements;if((h=H.loadMode)&&M<8&&(e=d.length)){t=0;N++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(o=d[t][$]("data-expand"))||!(n=o*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&M<1&&N>2&&h>2&&!D.hidden){w=f;N=0}else if(h>1&&N>1&&M<6){w=u}else{w=_}}if(l!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;l=n}a=d[t].getBoundingClientRect();if((b=a.bottom)>=s&&(g=a.top)<=z&&(C=a.right)>=s*c&&(p=a.left)<=y&&(b||C||p||g)&&(H.loadHidden||x(d[t]))&&(m&&M<3&&!o&&(h<3||N<4)||W(d[t],n))){R(d[t]);r=true;if(M>9){break}}else if(!r&&m&&!i&&M<4&&N<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!o&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){i=v[0]||d[t]}}if(i&&!r){R(i)}}};var a=ae(t);var S=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}L(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,B);X(t,"lazyloaded")};var i=te(S);var B=function(e){i({target:e.target})};var T=function(e,t){var a=e.getAttribute("data-load-mode")||H.iframeLoadMode;if(a==0){e.contentWindow.location.replace(t)}else if(a==1){e.src=t}};var F=function(e){var t;var a=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(a){e.setAttribute("srcset",a)}};var s=te(function(t,e,a,i,r){var n,s,o,l,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(i){if(a){K(t,H.autosizesClass)}else{t.setAttribute("sizes",i)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){o=t.parentNode;l=o&&j.test(o.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||l);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(L,2500);V(t,B,true)}if(l){G.call(o.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!l){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||l)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,H.fastLoadedClass)}S(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){M--}},true)});var R=function(e){if(e._lazyRace){return}var t;var a=n.test(e.nodeName);var i=a&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=i=="auto";if((r||!m)&&a&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;M++;s(e,t,r,i,a)};var r=ie(function(){H.loadMode=3;a()});var o=function(){if(H.loadMode==3){H.loadMode=2}r()};var l=function(){if(m){return}if(f.now()-e<999){I(l,999);return}m=true;H.loadMode=3;a();q("scroll",o,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",a,true);q("resize",a,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(a).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",a,true);O[P]("DOMAttrModified",a,true);setInterval(a,999)}q("hashchange",a,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,a,true)});if(/d$|^c/.test(D.readyState)){l()}else{q("load",l);D[P]("DOMContentLoaded",a);I(l,2e4)}if(k.elements.length){t();ee._lsFlush()}else{a()}},checkElems:a,unveil:R,_aLSL:o}}(),re=function(){var a;var n=te(function(e,t,a,i){var r,n,s;e._lazysizesWidth=i;i+="px";e.setAttribute("sizes",i);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",i)}}if(!a.detail.dataAttr){Y(e,a.detail)}});var i=function(e,t,a){var i;var r=e.parentNode;if(r){a=s(e,r,a);i=X(e,"lazybeforesizes",{width:a,dataAttr:!!t});if(!i.defaultPrevented){a=i.detail.width;if(a&&a!==e._lazysizesWidth){n(e,r,i,a)}}}};var e=function(){var e;var t=a.length;if(t){e=0;for(;e<t;e++){i(a[e])}}};var t=ie(e);return{_:function(){a=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:i}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});